import { render } from "./NewNotification.vue?vue&type=template&id=437cc1c8&scoped=true"
import script from "./NewNotification.vue?vue&type=script&lang=js"
export * from "./NewNotification.vue?vue&type=script&lang=js"

import "./NewNotification.vue?vue&type=style&index=0&id=437cc1c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437cc1c8"]])

export default __exports__